// Generated by purs version 0.15.15
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Types_BeginCheckout from "../Restaumatic.Analytics.Types.BeginCheckout/index.js";
import * as Restaumatic_Analytics_Types_Event from "../Restaumatic.Analytics.Types.Event/index.js";
import * as Restaumatic_Analytics_Types_Item from "../Restaumatic.Analytics.Types.Item/index.js";
import * as Restaumatic_Analytics_Types_PurchaseItem from "../Restaumatic.Analytics.Types.PurchaseItem/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var getField = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_Item.hasFieldItem(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "price";
    }
})()));
var quantityIsSymbol = {
    reflectSymbol: function () {
        return "quantity";
    }
};
var getField1 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_Item.hasFieldItem(/* #__PURE__ */ Data_Record.hasFieldRecord(quantityIsSymbol)()));
var getField2 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_Item.hasFieldItem(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "name";
    }
})()));
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var hasFieldRecord = /* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "items";
    }
})();
var getField3 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_PurchaseItem.hasFieldPurchaseItem(hasFieldRecord));
var getField4 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_PurchaseItem.hasFieldPurchaseItem(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "total";
    }
})()));
var getField5 = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Restaumatic_Analytics_Types_BeginCheckout.hasFieldBeginCheckout(hasFieldRecord));
var sum = /* #__PURE__ */ Data_Numeric.sum(Data_Foldable.foldableArray)(Data_Numeric.additiveNumber);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var recordEncode = /* #__PURE__ */ Foreign_Generic_Class.recordEncode();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeRecordCons2 = /* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1({
    reflectSymbol: function () {
        return "value";
    }
})(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)));
var currencyIsSymbol = {
    reflectSymbol: function () {
        return "currency";
    }
};
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var contentsIsSymbol = {
    reflectSymbol: function () {
        return "contents";
    }
};
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode);
var encodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(/* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(quantityIsSymbol)(encodeWithOptionsOther1))({
    reflectSymbol: function () {
        return "id";
    }
})(encodeWithOptionsOther))));
var encodeRecordCons3 = /* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons2(currencyIsSymbol)(encodeWithOptionsOther))(contentsIsSymbol)(encodeWithOptionsOther2);
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons(encodeRecordCons3)({
    reflectSymbol: function () {
        return "content_type";
    }
})(encodeWithOptionsOther)));
var encode1 = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ recordEncode(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons2({
    reflectSymbol: function () {
        return "num_items";
    }
})(encodeWithOptionsOther1))(currencyIsSymbol)(encodeWithOptionsOther))(contentsIsSymbol)(encodeWithOptionsOther2)));
var encode2 = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ recordEncode(encodeRecordCons3));
var itemValue = function (item) {
    return Data_Money_Rounded.toNumber(getField(Type_Proxy["Proxy"].value)(item)) * Data_Int.toNumber(getField1(Type_Proxy["Proxy"].value)(item));
};
var itemToContent = function (item) {
    return {
        id: getField2(Type_Proxy["Proxy"].value)(item),
        quantity: getField1(Type_Proxy["Proxy"].value)(item)
    };
};
var toPlatformEvent = function (currency) {
    var purchase = function (item) {
        return {
            contents: map(itemToContent)(getField3(Type_Proxy["Proxy"].value)(item)),
            value: Data_Money_Rounded.toNumber(getField4(Type_Proxy["Proxy"].value)(item)),
            currency: currency
        };
    };
    var beginCheckout = function (e) {
        return {
            contents: map(itemToContent)(getField5(Type_Proxy["Proxy"].value)(e)),
            value: sum(map(itemValue)(getField5(Type_Proxy["Proxy"].value)(e))),
            num_items: length(getField5(Type_Proxy["Proxy"].value)(e)),
            currency: currency
        };
    };
    var addToCart = function (item) {
        return {
            content_type: "product",
            contents: [ itemToContent(item) ],
            value: itemValue(item),
            currency: currency
        };
    };
    return function (v) {
        if (v instanceof Restaumatic_Analytics_Types_Event.AddToCart) {
            return new Data_Maybe.Just({
                name: "AddToCart",
                value: encode(addToCart(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.LocateMe) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.RemoveFromCart) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.BeginCheckout) {
            return new Data_Maybe.Just({
                name: "InitiateCheckout",
                value: encode1(beginCheckout(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.Purchase) {
            return new Data_Maybe.Just({
                name: "Purchase",
                value: encode2(purchase(v.value0))
            });
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.SetCheckoutOption) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.SuggestionResult) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ExperienceImpression) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.NotOverlappingDishes) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.VisitPage) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ChooseDelivery) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ChooseTakeaway) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ChooseAddress) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ChooseDineIn) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ChooseDate) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.FindAddress) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.ReviewGoogleLinkShown) {
            return Data_Maybe.Nothing.value;
        };
        if (v instanceof Restaumatic_Analytics_Types_Event.OrderingImpossibleAlert) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Tracking.Facebook (line 47, column 28 - line 65, column 43): " + [ v.constructor.name ]);
    };
};
export {
    toPlatformEvent
};
